import { useTranslation } from 'react-i18next';
import { BarChart3, Table2, GanttChartSquare } from 'lucide-react';
import { cn } from '@/core/lib/utils';
import { PERFORMANCE_TAB } from '../types';
import type { PerformanceTab } from '../types';

interface ViewTabsProps {
  activeTab: PerformanceTab;
  onChange: (tab: PerformanceTab) => void;
}

export function ViewTabs({ activeTab, onChange }: ViewTabsProps) {
  const { t } = useTranslation('laborPerformance');

  const TABS = [
    { value: PERFORMANCE_TAB.TIMELINE, label: t('tabs.timeline'), icon: GanttChartSquare },
    { value: PERFORMANCE_TAB.TABLE, label: t('tabs.table'), icon: Table2 },
    { value: PERFORMANCE_TAB.CHART, label: t('tabs.chart'), icon: BarChart3 },
  ] as const;

  return (
    <div className="flex items-center rounded-lg border bg-muted/40 p-1 gap-1">
      {TABS.map(({ value, label, icon: Icon }) => (
        <button
          key={value}
          type="button"
          onClick={() => onChange(value)}
          data-testid={`labor-performance-tab-${value}`}
          aria-pressed={activeTab === value}
          className={cn(
            'flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
            activeTab === value
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground',
          )}
        >
          <Icon className="h-4 w-4" />
          {label}
        </button>
      ))}
    </div>
  );
}
